<template>
  <button
    type="button"
    @click="onClick"
    :aria-label="message ? 'Main Menu (you have unread messages)' : 'Main Menu'"
    aria-haspopup="menu"
    :aria-expanded="open">
    <svgicon
      v-if="open"
      aria-hidden="true"
      original
      data="@iconPath/glyph/32/close.svg?inline"
      width="32"
      height="32"></svgicon>
    <svgicon
      v-else
      aria-hidden="true"
      original
      data="@iconPath/glyph/32/bars.svg?inline"
      width="32"
      height="32"></svgicon>
    <div
      v-if="message"
      class="messageicon">
      <span>
        <svgicon
          aria-hidden="true"
          original
          data="@iconPath/glyph/12/email.svg?inline"
          width="12"
          height="12"></svgicon>
      </span>
    </div>
  </button>
</template>

<script>
import Legacy from '@/core/legacy'
export default {
  name: 'MenuButtonComponent',
  data() {
    return {
      showMenuState: false
    }
  },
  computed: {
    open() {
      return this.showMenuState
    },
    message() {
      const messageExists = $('.menuitem.messagecenter .menuitem__text').html()
        ? $('.menuitem.messagecenter .menuitem__text')
            .html()
            .replace(/[^0-9]/g, '')
        : ''

      return messageExists > 0
    }
  },
  methods: {
    onClick() {
      this.showMenuState = !this.showMenuState
      Legacy.showMenu(this.showMenuState)
    }
  }
}
</script>

<style lang="less">
@import '../assets/css/abstract/variables.less';

.messageicon {
  position: absolute;
  top: -10%;
  left: 50%;
  width: 24px;
  height: 24px;
  background-color: @tertiary-color;
  border-radius: 31px;
  border: solid 1px @controls-border-color;

  .svg-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -6px !important;
    margin-left: -6px !important;
  }
}
</style>
